import { CreateEntityTypeRequest } from '../../../../web-api-client';
import { EntityType } from '../../models';
import { mapEntityTypeInvJurisdictionRequest } from '../entity-type-investment-jurisdiction/map-entity-type-investment-jurisdiction-request';

export const mapEntityTypeToCreateRequest = (
  entityType: EntityType
): CreateEntityTypeRequest => {
  return new CreateEntityTypeRequest({
    name: entityType.name,
    description: entityType.description,
    countryId: entityType.country?.countryId,
    isActive: entityType.isActive,
    entityTypeInvestmentJurisdiction:
      entityType.entityTypeInvestmentJurisdiction
        ? entityType.entityTypeInvestmentJurisdiction.map(
            mapEntityTypeInvJurisdictionRequest
          )
        : [],
  });
};
